import { LegalAttributeValue } from "../../../../../api/types"
import {
  ObjectValidatorsMap,
  ObjectMapValidator,
  rangeCharactersValidator,
} from "../../../../../components/Validator"

const DropdownChoiceValidatorMap: ObjectValidatorsMap<LegalAttributeValue> = {
  value: rangeCharactersValidator(
    -1,
    100,
    "The value has a max length of 100 characters."
  ),
}

const DropdownChoiceValidator = new ObjectMapValidator<LegalAttributeValue>(
  DropdownChoiceValidatorMap
)

export default DropdownChoiceValidator
